;
(function ($) {

    function Mask() {
        $('[name=phone]').mask('(00) 0000-0000');
        $('[name=cellphone]').mask('(00) 00000-0000');
        $('[name=cpf]').mask('999.999.999-99');
        $("[name=cnpj]").mask("99.999.999/9999-99");
        $("[name=postal_code], [name=cep]").mask("99999-999");
        $('[data-money]').mask('000.000.000.000.000,00', {
            reverse: true
        });
        
        $('#value_nfe').mask('000.000.000.000.000,00', {
            reverse: true
        });
        $('[data-integrate], [name=hours_consumed], [name=hours_charged]').mask('0#');
        $('[data-percentage]').mask('##0.00', {
            reverse: true
        });
        $('[data-cref]').mask('999999-A/AA'); 

        //Validação do dia digitado

        $('[data-day]').mask("99", {
            onKeyPress: function (val, e, field, options) {
                if (val > 31) {
                    $(field).val(31);
                }
            }
        });
    }

    new Mask();

}(jQuery));